import React from 'react'
import { FootPrintType } from 'src/core/models'
import { getTransformedDate } from 'src/core/helpers'
import styles from './FootprintMovileViewColumn.module.scss'
import { FormLabels, CustomTitle, FootPrintListActionColumn } from 'src/components'

const FootprintMovileViewColumn: React.FC<{ footprint: FootPrintType }> = ({ footprint }) => {

  const subtitle = `${footprint.footprint_type.name} (${footprint.description})`

  return <div className={styles.mobileView}>
    <FormLabels
      title={footprint.name}
      subtitle={subtitle}
      thirdLabel={getTransformedDate(footprint.date_of_footprint)}
    />

    <div className={styles.content}>
      <CustomTitle label={`${footprint.co2_amount} tCO₂`} />
      <div className={styles.actions}>
        <FootPrintListActionColumn footprint={footprint} />
      </div>
    </div>
  </div>
}

export default FootprintMovileViewColumn
